module.exports = __webpack_public_path__ + "static/fonts/Fact-SemiExpandedMedium.381bde4.ttf";